export const SET_NAV = (state, navbar) => {
    state.navbar = navbar;
};

export const SET_SECTION_HOVER = (state, sectionHoverId) => {
    state.sectionHover = sectionHoverId;
};

export const SET_NAVBAR_RE_RENDER = (state, payload) => {
    state.navbarReRender = payload;
};

export const SET_LAYOUT_STYLE = (state, layout) => {
    state.layoutStyle = Object.assign(state.layoutStyle, layout)
};

export const SET_OPEN_STYLE_FROM_SECTION = (state, id) => {
    state.openStyleFromSection = id
};

export const SET_SELECTED_PAGE = (state, payload) => {
    state.selectedPage = payload;
};
  
  